<template>
    <div class="card" style="min-height: calc(100vh - 180px)">
        <div class="bg-blue-light p-1">
            <TitleButton
                :showBtn="false"
                title="Asset Register"
                btnTitle="Add New"
                :showAddNew="true"
                @onClickAddNewButton="onClickAddNewButton"
            />
        </div>

        <div class="px-2">
           <div class="row">
             <DateQuerySetter
                 btnTitle="Go"
                 @onClickGo="getAssetRegisterList"
                 class="tds-vds-query-setter"
             >
               <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                 <label for="colFormLabel" class="col-form-label">Group: </label>
                 <AsyncSelect
                     placeholder="Select Group"
                     v-model="selectGroup"
                     :api-service="fetchProductList"
                     :format-label="option => option.text"
                     label="text"
                     :additional-query="{ product_type: 'fixed_assets', group_level:1 }"
                 />
               </div>

               <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                 <label for="colFormLabel" class="col-form-label">Class Name: </label>
                 <AsyncSelect
                     placeholder="Select Class Name"
                     v-model="selectedProduct"
                     :api-service="fetchProductList"
                     :format-label="option => option.text"
                     label="text"
                     :additional-query="{ product_type: 'fixed_assets' }"
                 />
               </div>

               <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                 <label for="colFormLabel" class="col-form-label">Location: </label>
                 <AsyncSelect
                     placeholder="Select Location"
                     v-model="businessLocation"
                     :api-service="fetchBusinessLocationsList"
                     label="text"
                     :format-label="option => option.text"
                     :additional-query="{ location_type: 'fixed_assets' }"
                 />
               </div>

               <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                 <label for="colFormLabel" class="col-form-label">Department: </label>
                 <AsyncSelect
                     placeholder="Select Department"
                     v-model="department"
                     :api-service="fetchDepartmentList"
                     :format-label="option => option.name"
                     label="name"
                 />
               </div>

               <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                 <div class="d-flex align-items-center justify-content-between filter-label">
                   <label for="colFormLabel" class="col-form-label">Assign Custodian: </label>
                   <span class="filter-search-icon cursor-pointer" @click="onOpenContactSearchModal">
                            <i class="fas fa-search"></i>
                        </span>
                 </div>

                 <AsyncSelect
                     placeholder="Select Custodian"
                     v-model="contactProfile"
                     :api-service="fetchContactProfiles"
                     :additional-query="{type: 'employee'}"
                 />
               </div>
             </DateQuerySetter>
           </div>
        </div>
        <div class="col-12 px-2 mt-1">
          <div class="card" style="min-height: 200px">
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th>Asset ID</th>
                  <th>Tag Status</th>
                  <th>Name</th>
                  <th>Asset Class</th>
                  <th>Asset Location</th>
                  <th>Custodian</th>
                  <th>Capitalization Date</th>
                  <th>Bill Date</th>
                  <th>Asset Value</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in assetRegisterList" :key="i">
                  <td>{{ item.id }}</td>
                  <td>No</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.product_name }}</td>
                  <td>{{ item.business_location_name }}</td>
                  <td>{{ item.contact_profile_name }}</td>
                  <td>{{ item.format_capitalization_date }}</td>
                  <td>{{ item.format_bill_date }}</td>
                  <td>{{ item.asset_value }}</td>
                  <td>
                    <button class="btn btn-primary btn-sm"
                            @click="goToEdit(item)"
                            style="cursor: pointer"
                    >
                      <i class="fas fa-eye"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
              <p v-if="!assetRegisterList.length" class="text-center mt-5">No data</p>
            </div>
          </div>

          <div class="px-2">
            <Pagination :offset="offset" @onPageChange="onPageChange" ref="pagination"/>
          </div>

        <ContactDropdownFilter
            v-if="store.state.isModalOpenThree"
            @onSearchContact="onSearchContact"
            type="customer"
        />
        <GlobalLoader />
    </div>
    </div>
</template>

<script setup>
import { ref, inject, reactive, onMounted, computed  } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import handleAssetRegister from '@/services/modules/assetRegister/assetRegister'
import TitleButton from '@/components/atom/TitleButton'
import Pagination from '@/components/atom/Pagination'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleContact from "@/services/modules/contact";
import ContactDropdownFilter from "@/components/atom/Contact/ContactDropdownFilter.vue";
import handlePurchaseAndSales from "@/services/modules/purchase";
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import handleBusinessesLocations from '@/services/modules/businessesLocations'
import handleDepartments from "@/services/modules/procurement/organization-settings/department";

const router = useRouter()
const store = useStore()
let offset = ref(20)
let assetRegisterList = ref([])
const route = useRoute()
let contactProfile = ref(null)
let billNumber = ref(null)
const selectedProduct = ref(null);
const selectGroup = ref(null);
const businessLocation = ref(null);
const department = ref(null);

const { fetchAssetRegister } = handleAssetRegister()
const { fetchContactProfiles } = handleContact();
const { fetchProductList } = handlePurchaseAndSales()
const { fetchBusinessLocationsList } = handleBusinessesLocations()
const { fetchDepartmentList } = handleDepartments()

const companyId = computed(() => {
    return route.params.companyId
})

function getQuery () {
  let queryStr = '?company_id=' + route.params.companyId
  queryStr += '&offset=' + offset.value
  if (route.query.page) queryStr += "&page=" + route.query.page;
  if(contactProfile.value) queryStr += '&contact_profile_id=' + contactProfile.value.id;
  if(selectedProduct.value) queryStr += '&product_id=' + selectedProduct.value.id;
  if(selectGroup.value) queryStr += '&group_id=' + selectGroup.value.id;
  if(businessLocation.value) queryStr += '&business_location_id=' + businessLocation.value.id;
  if(department.value) queryStr += '&department_id=' + department.value.id;
  if (route.query.start) queryStr += '&start_date=' + route.query.start;
  if (route.query.end) queryStr += '&end_date=' + route.query.end;
  return queryStr
}

function onClickAddNewButton() {
  router.push({name: `asset-register-add`, params: route.params, query: route.query})
}

function getAssetRegisterList() {
    const query = getQuery();
    const queryString = new URLSearchParams(query);

  fetchAssetRegister("?" + queryString.toString())
    .then(res => {
        if (!res.status){
          assetRegisterList.value = []
          store.commit("resetPagination")
          return
        }
        assetRegisterList.value = res.data.data
        setPagination(res.data)
    })
}

function setPagination(data) {
    if(!data.data.length) return
    store.commit('setPaginationData', {
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    })
}

async function onPageChange(page) {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    await router.push({path: route.path, query: routeQuery})
    getAssetRegisterList()
}

const goToEdit = (item) => {
  let param = {
    companyId: route.params.companyId,
    moduleId: route.params.moduleId,
    menuId: route.params.menuId,
    pageId: route.params.pageId
  }

  let query = route.query;
  query.assetRegisterId = item.id;

  router.push({
    name:  'asset-register-add',
    params: param,
    query: query
  })
}

const onOpenContactSearchModal = () => {
    store.state.isModalOpenThree = true;
}

const onSearchContact = (contact) => {
    contactProfile.value = contact
}

</script>
